import "./App.css";
import React, { Component } from "react";
import { CircularProgress, withStyles } from "@material-ui/core";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import axios from "axios";
import { Provider, connect } from "react-redux";
import store from "redux/Store";
import { forgetLoggedInUser, setUserFromAuth0 } from "./redux/actions/UserActions";
import { loadRuntime } from "redux/actions/OrgRuntimeActions";
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Auth0Home from "util/auth0-components/Auth0Home";
import ToUrl from "util/auth0-components/ToUrl";
import LogoutWithRedirect from "util/auth0-components/LogoutWithRedirect";
import BulkEdit from "./modules/bulk-edit/BulkEdit";
import Downloader from "./modules/ml-downloader/downloader/Downloader";
// import { socket } from './socket';

// const Home = React.lazy(() => import("pages/home/Home"));
const Terms = React.lazy(() => import("pages/terms/terms"));
// const Signup = React.lazy(() => import("pages/signup/Signup"));
const SignupStep1 = React.lazy(() => import("pages/signupStep1/SignupStep1"));
// const SignupOrg = React.lazy(() => import("pages/signupOrg/SignupOrg"));
const Contact = React.lazy(() => import("./pages/contact/Contact"));
const LoginFailed = React.lazy(() => import("./pages/LoginFailed/LoginFailed"));
const CueSheet = React.lazy(() => import("./pages/CueSheetLink/CueSheetMain"));
const NoCueSheet = React.lazy(() => import("./pages/CueSheetLink/no-cuesheet/NoCueSheet"));
const NoPermission = React.lazy(() => import("./pages/CueSheetLink/noPermission/NoPermission"));
const manageCueSheetCFContent = React.lazy(() => import("./pages/CueSheetLink/CueSheet-CFContent/Table"));

const urlParams = new URLSearchParams(window.location.search);
const returnTo = urlParams.get("returnTo")?atob(urlParams.get("returnTo")):null;

export const appConfig = window._env_;

axios.defaults.baseURL = appConfig.CENTRAL_API;
axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  function (successRes) {
    return successRes;
  },
  function (error) {
    if (error?.response?.status === 401) {  
     if(error?.response && error?.response.config && error?.response?.config.url && (error?.response?.config?.url).includes("cuesheet")){
      let cueSheetId = localStorage.getItem('cuesheet_id');
        window.location.replace(`${appConfig.SM_STANDARD_CS_URL}${cueSheetId}`);
      }  
      else{
        forgetLoggedInUser()
        window.location.replace(`/logoutWithRedirect`);
      }
      
      throw error;
    }
    else if(error?.response?.status === 403){
      if(error?.response && error?.response.config && error?.response?.config.url && (error?.response?.config?.url).includes("cuesheet")){
        window.location.replace(`/nopermission`);
        }  
        else{
          forgetLoggedInUser()
          window.location.replace(`/logoutWithRedirect`);
        }
        
      throw error;

    } else {
      throw error;
    }
  }
);

export const paging_type = appConfig.PAGING_TYPE;

store.dispatch(loadRuntime());
const theme = createMuiTheme({
  palette: {
    type: "dark",
  },
});

const styles = (theme) => ({
  appContainer: {},
});

let options = {
  returnTo: returnTo?returnTo:"/search/tracks", 
  loginOptions: {
    authorizationParams: {
      audience: appConfig.AUTH0_AUDIENCE
      // organization: data.auth0OrgId // FOR ORG SPECIFIC LOGIN (FIRST LOGIN)
    }
  }
}
const auth0Home = withAuthenticationRequired(Auth0Home, {
  // Show a message while the user waits to be redirected to the login page.
  onRedirecting: () => (<div className="loader"><CircularProgress  /></div>), 
  ...options
});

class App extends Component {
  constructor() {
    super();
    this.state = {};
  }

  // componentDidMount() {
  //   function onConnect() {
  //     console.log('Connected to server');
  //     socket.on("notification", (data, callback)=>{
  //       console.log(`>>>on notification data`, data);
  //       // Acknowledge receipt
  //       callback({ status: 'OK', receivedAt: new Date() });
  //     });
  //   }

  //   function onDisconnect() {
  //     console.log('Disconnected from server');
  //   }

  //   socket.on('connect', onConnect);
  //   socket.on('disconnect', onDisconnect);

  //   return () => {
  //     socket.off('connect', onConnect);
  //     socket.off('disconnect', onDisconnect);
  //   };
  // }
  
  render() {
    const { classes } = this.props;
    loadRuntime();
    return (
      <ThemeProvider theme={theme}>
        {/* <Provider store={store}> */}
          <BrowserRouter basename="">
            <div className={classes.appContainer} role="main">
              <Switch>
                <Route path="/loginfailed" component={LoginFailed} />
                <Route path="/tourl" component={ToUrl} />
                <Route path="/contact" component={Contact} />
                {/* <Route path="/signup/:handle" component={Signup} /> */}
                {/* <Route path="/signuporg/:handle" component={SignupOrg} /> */}
                <Route path="/signupstep1" component={SignupStep1} />
                <Route path="/logoutwithredirect" component={LogoutWithRedirect} />
                <Route path="/terms" component={Terms} />
                <Route path="/uploads/:type/bulk-edit/:org/:handle" component={BulkEdit} />
                <Route path="/cuesheet/:csId" component={CueSheet} />
                <Route exact path="/cuesheetCfContent/:csId/:cfid" component={manageCueSheetCFContent} />
                <Route exact path="/csNotFound" component={NoCueSheet} />
                <Route exact path="/nopermission" component={NoPermission} />
                <Route path="/cuesheet" component={CueSheet} />
                <Route path="/" component={auth0Home} />

              </Switch>
            </div>
          </BrowserRouter>
        {/* </Provider> */}
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(App);
